import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { getUnknownErrorMessage } from "@/lib/error-message";
import { SETTINGS_PROFILE_QUERY_KEY } from "@/hooks/useSettingsData";
import { queryClient } from "@/lib/queryClient";
import {
  settingsService,
  type UpdateProfileDTO,
} from "@/services/SettingsService";

export const useUpdateProfileMutation = () =>
  useMutation({
    mutationFn: ({
      userId,
      ...data
    }: UpdateProfileDTO & { userId: string }) =>
      settingsService.updateProfile(userId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: SETTINGS_PROFILE_QUERY_KEY,
      });
      toast.success("Profile updated successfully!");
    },
    onError: (error: unknown) => {
      toast.error(getUnknownErrorMessage(error));
    },
  });

export const useUpdatePasswordMutation = () =>
  useMutation({
    mutationFn: (values: { currentPassword: string; newPassword: string }) =>
      settingsService.updatePassword(values.currentPassword, values.newPassword),
    onSuccess: () => {
      toast.success("Password updated successfully!");
    },
    onError: (error: unknown) => {
      toast.error(getUnknownErrorMessage(error));
    },
  });
